module.exports = __webpack_public_path__ + "static/img/yyzz.20fc651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yyzz.jpg
// module id = 63pq
// module chunks = 25